import React from "react";

const PackEntrepreneurContentAB = ({picture,optionTitle,optionText}) => {
  return(
    <div className="optionContainer">
      <img src={picture}/>
      <h3 className="optionTitle">{optionTitle}</h3>
      <p className="optionText">{optionText}</p>
    </div>
  )
}
export default PackEntrepreneurContentAB;



// WEBPACK FOOTER //
// ./src/components/buy/upsell/pack-entrepreneurAB-content.js